import type { CreateRelationRequest } from '@domains/subscription/priv/Relations/api/api'
import { useCreateRelation, useRelationTemplates } from '@domains/subscription/priv/Relations/api/queries'
import { CreateRelationForm } from '@domains/subscription/priv/Relations/usecases/CreateRelationForm'

interface CreateRelationFormFactoryProps {
  onClose: () => void
}

export const CreateRelationFormFactory = ({ onClose }: CreateRelationFormFactoryProps) => {
  const { data: templates = [] } = useRelationTemplates()
  const createRelation = useCreateRelation()

  const handleCreateRelation = async (relation: CreateRelationRequest) => {
    await createRelation.mutateAsync(relation)
    onClose()
  }

  return <CreateRelationForm templates={templates} onCreateRelation={handleCreateRelation} isCreating={createRelation.isLoading} />
}
